<template>
  <div @click="dropdownEnabled=false">
    <div>
      <img :src="selectedIcon">
    </div>
    <div class="dropdown" :class="{'is-active':dropdownEnabled}">
      <div class="dropdown-trigger">
        <button
          class="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu2"
          @click.stop="dropdownEnabled=!dropdownEnabled"
        >
          <span>Selecciona una icona</span>
          <span class="icon is-small">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="dropdown-menu2" role="menu">
        <div class="dropdown-content">
          <div v-for="(icon,index) in icons" :key="index">
            <img :src="icon" @click="selectIcon(index)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { inputProps } from '@/mixins/FormInputMixin'
import _ from 'underscore'
export default {
  name: 'form-icon',
  mixins: [inputProps],
  data () {
    return {
      dropdownEnabled: false,
      selectedIcon: this.value ? require('@/assets/icons/' + this.value) : '',
      iconsSource: _.map(
        require.context('@/assets/icons', false, /@1x\.png$/).keys(),
        icon => icon.split('./')[1]
      )
    }
  },
  methods: {
    selectIcon: function (index) {
      this.selectedIcon = require('@/assets/icons/' + this.iconsSource[index])
      this.$emit('input', this.iconsSource[index])
    }
  },
  computed: {
    icons: function () {
      return _.map(this.iconsSource, icon => {
        return require('@/assets/icons/' + icon)
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
